import { useEffect, useState } from 'react';
import './App.css';
import { OrgChartComponent } from './OrgChart';
import { makeStyles } from '@material-ui/core/styles';
import { SelectionCard } from './SelectionCard';
import { Fab, Grid } from '@material-ui/core';
import { Share, Facebook } from '@material-ui/icons';
import { toBlob } from 'html-to-image';
import { saveAs } from 'file-saver';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  HashRouter
} from "react-router-dom";

import {
  FacebookShareButton,
  FacebookMessengerIcon,
  WhatsappIcon,
} from "react-share";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

export default function ParamsExample() {
  return (
    <HashRouter>
      <Switch>
        <Route exact path={"/"} children={<App />} />
        <Route path={"/:candidates"} children={<App />} />
      </Switch>
    </HashRouter>
  );
}

function App() {
  const classes = useStyles();
  let { candidates } = useParams();
  return (
    <div className="App">
      <header className="App-header">
        {/* <SelectionCard /> */}
        <OrgChartComponent candidates={candidates} />
        <Grid container className={classes.fab} justifyContent="flex-end">
          <Fab variant="extended" color="primary" aria-label="add"
            onClick={() => {
              toBlob(document.getElementById('TREE'))
                .then(function (blob) {
                  saveAs(blob, 'my-Cabinet.png');
                });

            }}
            className={classes.margin}>
            <Share className={classes.extendedIcon} />
            Export
          </Fab>
          <FacebookShareButton
            quote={`
            This is my government cabinet

            make your own at:

            https://im28.github.io/malaysian-cabinet/
            `}
            url={window.location.href}
          >
            <Fab variant="extended" color="primary" aria-label="add"
              onClick={() => {

              }}
              className={classes.margin}>
              <Facebook className={classes.extendedIcon} />
              Share

            </Fab>
          </FacebookShareButton>


        </Grid>


      </header>
    </div >
  );
}

//export default App;
